/**
 * Vorbelegung fuer „Aufgabe erstellen" aus der Mail-Ansicht (#188).
 *
 * Frueher stand hier `plan.reasoning` — die Ein-Satz-Begruendung der KI fuer
 * die Szenariowahl, gedacht fuer den Pruefer, nicht fuer den Empfaenger der
 * Aufgabe. Die Reihenfolge jetzt: Aufgabentext aus dem Plan (`monteur_task`),
 * dann `handlungsbedarf`, dann ein kurzer Auszug des Mailtexts. Die interne
 * Begruendung taucht nirgends auf.
 */

export const AUSZUG_MAX = 400

/** Kurzer Auszug aus dem Mailtext: ohne Zitatzeilen, Leerraum zusammengezogen,
 *  hoechstens `max` Zeichen, am Wortende gekuerzt. */
export function mailAuszug(text: string | null | undefined, max: number = AUSZUG_MAX): string {
  const zeilen = (text || "")
    .split(/\r?\n/)
    .filter((z) => !z.trim().startsWith(">"))
  const eins = zeilen.join(" ").replace(/\s+/g, " ").trim()
  if (eins.length <= max) return eins
  const schnitt = eins.slice(0, max)
  const letztesLeer = schnitt.lastIndexOf(" ")
  const kurz = letztesLeer > max * 0.6 ? schnitt.slice(0, letztesLeer) : schnitt
  return `${kurz.trimEnd()} …`
}

export function aufgabenVorbelegung(opts: {
  monteurTask?: { title?: string | null; body?: string | null } | null
  handlungsbedarf?: string | null
  mailText?: string | null
}): string {
  const t = opts.monteurTask
  return (
    (t?.body || "").trim()
    || (t?.title || "").trim()
    || (opts.handlungsbedarf || "").trim()
    || mailAuszug(opts.mailText)
  )
}

/**
 * #128 — Frist, Empfaenger und Zwischenantwort aus dem Plan fuer „Aufgabe aus
 * E-Mail". Das Buero legt die Chef-Rueckfrage (#83) oft ueber diesen Knopf an
 * statt ueber den Plan; ohne Vorbelegung kam sie ohne Frist beim Chef an und
 * die vorbereitete Zwischenantwort blieb liegen. `empfaenger` im Format des
 * Auswahlfelds („user_id|name“).
 */
export function aufgabeAusPlan(plan: {
  planweg?: string | null
  monteur_task?: { due_date?: string | null; target_user_id?: number | null; target_user_name?: string | null } | null
  reply?: { body?: string | null } | null
} | null | undefined): { frist: string | null; empfaenger: string | null; zwischenantwort: boolean } {
  const mt = plan?.monteur_task
  const frist = (mt?.due_date || "").trim() || null
  const empfaenger = mt?.target_user_id ? `${mt.target_user_id}|${(mt.target_user_name || "").trim()}` : null
  const zwischenantwort = plan?.planweg === "chef_rueckfrage" && !!(plan.reply?.body || "").trim()
  return { frist, empfaenger, zwischenantwort }
}
